import { createFormContext } from '@mantine/form';

interface FormValues {
  name: string;
  company: string;
  phone: string;
  email: string;
  message: string;
  check: boolean;
}

export const [FormProvider, useFormContext, useForm] = createFormContext<FormValues>();
